import React, { useState, useEffect } from "react";
import { TextField, Typography ,   Backdrop ,CircularProgress } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import ProfileHeader from "../../../components/ProfileHeader";
import ProfileBottomNav from "../../../components/ProfileBottomNav";
import { emailToDirectorate } from "../../../api/ProfileApi";
import { USER_SO_KEY } from "../../../utils/accountUtils";
import { getSessionStorage } from "../../../utils/StorageUtil";
import { useNavigate } from "react-router-dom";

import SuccessDialog from "../../../components/succesDialog";

import { useToastContext } from '../../../context/ToastContext'
import { ToastType } from '../../../components/toast/ToastType'


const Contact = () => {
  const user = getSessionStorage(USER_SO_KEY);
  const navigate = useNavigate();
  const [SuccessDialogOpen, setSuccessDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState({ title: "", message: "" });
  const [data, setData] = useState([]);
  const [, , showToast] = useToastContext();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (user.role !== "RESPONSABLE_FLOTA") {
      navigate("/web/");
    }
  }, [user]);

  const [message, setMessage] = useState("");

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if(message && message.length > 1 ){

      const body = {
        userId: user.id,
        message: message,
      };
      setLoading(true);
      emailToDirectorate(body)
        .then((response) => {
          setDialogData({
            title: "Mensaje enviado",
            message:
              "Su mensaje ha sido enviado con éxito a los miembros del directorio de OLCA.",
          });
          setSuccessDialogOpen(true);
          setLoading(false);
        })
        .catch((e) => {
          console.log("Error", e);
          setLoading(false);
          showToast(ToastType.Error, 'Error desconocido', e.message + ' - ' + e.request.responseURL)
      
        });

    }else{
      showToast(ToastType.Error, 'Error', 'El campo Mensaje es Obligatorio')
      
    }
    
  };

  const handleSuccessDialogClose = () => {
    navigate("/web/");
    setSuccessDialogOpen(false);
  };

  return (
    <Box
      sx={{
        background: {
          xs: "linear-gradient(#5EB07F 100px, #F2F3F1 155px)",
          sm: "#F2F3F1",
        },
        backgroundAttachment: "fixed",
      }}
    >
      <ProfileHeader></ProfileHeader>
      <Box p={2}>
        <Typography variant="h5" align="center" fontWeight="bold">
          Contactar al Directorio
        </Typography>
      </Box>
      <form onSubmit={handleSubmit}>
        <Box
          borderRadius={3}
          bgcolor="white"
          p={2}
          width="90%"
          margin="0 auto"
          height="100%"
        >
          <Typography variant="body1" style={{ marginBottom: "8px" }}>
            Empresa: <strong>{user.company?.name}</strong>{" "}
          </Typography>
          <Typography variant="body1" style={{ marginBottom: "8px" }}>
            Usuario:{" "}
            <strong>
              {user.firstName} {user.lastName}
            </strong>{" "}
          </Typography>
          <Typography variant="body1" style={{ marginBottom: "8px" }}>
            E-mail: <strong>{user.email}</strong>{" "}
          </Typography>
          <div style={{ marginTop: "20px" }}>
            <TextField
              id="mensaje"
              label="Mensaje"
              multiline
              rows={4}
              variant="outlined"
              placeholder="ESCRIBA AQUI SU MENSAJE"
              value={message}
              onChange={handleMessageChange}
              fullWidth
            />
          </div>
        </Box>
        <SuccessDialog
          open={SuccessDialogOpen}
          handleClose={handleSuccessDialogClose}
          title={dialogData.title}
          message={dialogData.message}
        ></SuccessDialog>
        <ProfileBottomNav goBack={true} send={handleSubmit}></ProfileBottomNav>
      </form>

      {loading && (
        <Backdrop open={loading}>
          <CircularProgress color="primary" />
        </Backdrop>
      )}
    </Box>
  );
};

export default Contact;
